import React, { Dispatch, SetStateAction, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch } from '../../data/storeConfig';
import * as cartActions from '../../data/reducers/cart.reducer';
import { RootState } from '../../data/reducers';

const CouponInput = (params: {couponCode: string | null, setCouponCode: Dispatch<SetStateAction<string>>}) => {
const dispatch = useDispatch<AppDispatch>();

  const { shopperAccountId, phoneNumber } = useSelector((state: RootState) => state.authReducer);
  const { storeInfo } = useSelector((state: RootState) => state.storeReducer);
  const { addressInfo, applyCouponLoading, appliedCouponMessage, applyCouponError } = useSelector((state: RootState) => state.cartReducer);

  const handleApplyCoupon = async () => {
    await dispatch(cartActions.applyCoupon({
        shopperAccount: {
          shopperAccountId: shopperAccountId,
          phoneNumber: phoneNumber,
          fullName: addressInfo.fullName,
        },
        couponCode: params.couponCode,
        merchantStoreId: storeInfo?.merchantStoreId,
        fulfilmentType: addressInfo.OrderType,
      }));
  };

  return (
    <div className="">
      <div className="flex">
        <input
          type="text"
          placeholder="Coupon"
          value={params.couponCode ?? ''}
          onChange={(e) => params.setCouponCode(e.target.value?.trim())}
          className="w-full py-2 px-2 border rounded-l-lg"
        />

        <button
          onClick={handleApplyCoupon}
          disabled={applyCouponLoading}
          className={`bg-primaryViolet text-white rounded-r-lg w-full py-2 px-4 flex items-center mx-auto flex-1 ${
            applyCouponLoading ? 'opacity-50 cursor-not-allowed' : ''
          }`}
        >
          Apply
          {applyCouponLoading === true ? (
            <span className="loading loading-spinner loading-xs ml-2"></span>
          ) : (
            <></>
          )}
        </button>
      </div>

      <div
        className={
          applyCouponLoading || !appliedCouponMessage
            ? 'hidden'
            : !applyCouponError ? '-mt-2 w-full bg-primaryViolet bg-opacity-20 rounded-b-lg pt-2.5 pb-1 text-center text-primaryViolet shadow-lg transition-all' : '-mt-2 w-full bg-red-500 bg-opacity-20 rounded-b-lg pt-2.5 pb-1 text-center text-red-500 shadow-lg transition-all'
        }
      >
        {appliedCouponMessage ? (
          <p>{appliedCouponMessage}</p>
        ) : applyCouponLoading ? (
          <p>Loading...</p>
        ) : (
          <p>Apply a coupon code to get a discount.</p>
        )}
      </div>
    </div>
  );
};

export default CouponInput;
